import { jsx as _jsx } from "react/jsx-runtime";
import { FormContext } from "../hooks/use-form-store.js";
import { defaultWidgets } from "../widgets/default-widgets.js";
export function FormProvider({ store, widgets, previews, runtimeContext, forms, children }) {
    const mergedWidgets = widgets ? { ...defaultWidgets, ...widgets } : defaultWidgets;
    return (_jsx(FormContext.Provider, { value: { store, widgets: mergedWidgets, previews, runtimeContext, forms }, children: children }));
}
